import { WHATSAPP_TEMPLATES_PAGE_KEY } from './constants';
import type { TTranslations } from './types';

export const pt: TTranslations = {
  [WHATSAPP_TEMPLATES_PAGE_KEY]: {
    TABLE_TITLE: 'Modelos de WhatsApp',
    CREATE_TEMPLATE_BUTTON: 'Criar modelo',

    COLUMN_ALIAS: 'Alias',

    COLUMN_SLUG: 'Slug',
    COLUMN_DESCRIPTION: 'Descrição',
    COLUMN_META_NAME: 'Nome no WhatsApp',
    COLUMN_LANGUAGE: 'Idioma',
    COLUMN_META_TEMPLATE_ID: 'ID do WhatsApp',
    COLUMN_META_STATUS: 'Status no WhatsApp',
    COLUMN_CATEGORY: 'Categoria',
    COLUMN_PLACEHOLDERS: 'Variáveis',
    COLUMN_MAPPING: 'Mapeamento',
    COLUMN_LAST_SYNC: 'Última sincronização',

    LEGEND_LOCK_LABEL: 'Vem do WhatsApp, somente leitura',
    LEGEND_PENCIL_LABEL: 'Administrado pela Crehana',

    NOTICE_BAND_TEXT:
      'Os modelos são criados e aprovados no WhatsApp Manager. Aqui são importados somente para leitura.',
    NOTICE_BAND_LINK: 'Abrir o WhatsApp Manager',

    PRODUCT_SELECTOR_LABEL: 'Produto',
    PRODUCT_SELECTOR_ACCOUNT_LABEL: 'Conta de WhatsApp em uso',
    PRODUCT_UNAVAILABLE_TAG: 'Em breve',
    PRODUCT_RECRUITMENT: 'Recrutamento',
    PRODUCT_ENGAGEMENT: 'Engajamento',
    PRODUCT_LEARNING: 'Aprendizagem',
    PRODUCT_PAYROLL: 'Folha de pagamento',
    PRODUCT_PERFORMANCE: 'Desempenho',
    PRODUCT_PERSONAS_HRIS: 'Pessoas HRIS',

    SEARCH_PLACEHOLDER: 'Pesquisar por alias ou nome no WhatsApp',
    FILTER_META_STATUS_LABEL: 'Status no WhatsApp',
    FILTER_META_STATUS_ALL_OPTION: 'Todos',
    FILTER_INCOMPLETE_LABEL: 'Mapeamento incompleto',
    PAGE_SIZE_LABEL: 'Linhas por página',
    PAGINATION_SUMMARY: '{{from}}–{{to}} de {{total}}',
    FILTER_META_STATUS_CLEAR: 'Limpar o filtro de status',
    SORT_BY: 'Ordenar por {{column}}',
    SORT_ASCENDING: 'Ordem crescente',
    SORT_DESCENDING: 'Ordem decrescente',
    PAGINATION_LABEL: 'Paginação',
    PAGINATION_PREVIOUS: 'Página anterior',
    PAGINATION_NEXT: 'Próxima página',
    PAGINATION_PAGE: 'Página {{page}}',
    PAGINATION_PAGE_OF: 'Página {{page}} de {{total}}',
    PAGINATION_OF_TOTAL: 'de {{total}}',
    COLUMN_ACTIONS: 'Ações',
    NO_RESULTS_SEARCH_TITLE: 'Nenhum resultado encontrado para',
    NO_RESULTS_SEARCH_DESCRIPTION: 'Tente novamente com um termo diferente.',
    NO_RESULTS_FILTERS_TITLE: 'Sem resultados para exibir',
    NO_RESULTS_FILTERS_DESCRIPTION: 'Tente novamente com um filtro diferente.',

    INCOMPLETE_MAPPING_COUNTER: '{{count}} modelos com o mapeamento incompleto',

    LAST_SYNC_LABEL: 'Última sincronização: {{date}}',
    SYNC_ACTION_LABEL: 'Sincronizar',
    SYNC_ACTION_SYNCING_LABEL: 'Sincronizando...',
    SYNC_META_UNAVAILABLE_NOTICE:
      'O WhatsApp não respondeu. Estes são os modelos da última sincronização.',

    LAST_SYNC_NEVER: 'Última sincronização: sem dados',
    SYNC_TOAST_TITLE: 'Modelos sincronizados com o WhatsApp',
    SYNC_TOAST_DESCRIPTION:
      '{{updated}} atualizados · {{unchanged}} sem mudanças · {{missing}} não estão mais no WhatsApp · {{outdated}} com o mapeamento desatualizado',
    SYNC_ERROR_TITLE: 'Não foi possível sincronizar com o WhatsApp',
    SYNC_ERROR_META_NOT_CONFIGURED:
      'Este ambiente não tem a conexão com o WhatsApp configurada.',
    SYNC_ERROR_META_ACCESS_DENIED:
      'O WhatsApp recusou o acesso da Crehana aos seus modelos.',
    SYNC_ERROR_META_UNAVAILABLE:
      'O WhatsApp não respondeu. Tente novamente em alguns minutos.',
    SYNC_ERROR_GENERIC: 'Tente novamente.',
    SYNC_RESULT_TITLE: 'Revise estes modelos',
    SYNC_RESULT_MISSING: 'Não estão mais no WhatsApp: {{slugs}}',
    SYNC_RESULT_OUTDATED:
      'A mensagem mudou no WhatsApp. Edite o mapeamento antes do próximo envio: {{slugs}}',

    ROW_MENU_TRIGGER_LABEL: 'Mais ações',
    ROW_MENU_VIEW: 'Ver',
    ROW_MENU_EDIT: 'Editar',
    ROW_MENU_REMOVE: 'Remover do registro',

    PREVIEW_DIALOG_TITLE: 'Pré-visualização do modelo',
    PREVIEW_DIALOG_MESSAGE_LABEL: 'Mensagem',
    PREVIEW_DIALOG_PLACEHOLDERS_LABEL: 'Variáveis',
    PREVIEW_DIALOG_PLACEHOLDER_EXAMPLE_LABEL: 'Exemplo',
    PREVIEW_DIALOG_CLOSE: 'Fechar',

    REMOVE_DIALOG_TITLE: 'Remover do registro',
    REMOVE_DIALOG_DESCRIPTION:
      'O modelo continua no WhatsApp. Isso só o remove do registro da Crehana.',
    REMOVE_DIALOG_USED_BY_PRODUCT: 'O produto {{product}} o usa.',
    REMOVE_DIALOG_DETAIL:
      '«{{alias}}» ({{slug}}) sai do registro e não pode mais ser enviado. Nada muda no WhatsApp.',
    REMOVE_DIALOG_CONFIRM: 'Remover',
    REMOVE_DIALOG_CANCEL: 'Cancelar',
    REMOVE_TOAST_DONE: 'Modelo removido do registro. Slug: {{slug}}',
    REMOVE_TOAST_ERROR: 'Não foi possível remover o modelo',
    REMOVE_TOAST_ERROR_DESCRIPTION: 'Tente novamente.',

    EMPTY_STATE_TITLE: 'Ainda não há modelos registrados',
    EMPTY_STATE_DESCRIPTION:
      'Os modelos são criados no WhatsApp Manager. Importe-os para vê-los aqui.',

    ERROR_STATE_TITLE: 'Não foi possível carregar os modelos',
    ERROR_STATE_DESCRIPTION:
      'Ocorreu um erro ao carregar os modelos de WhatsApp.',
    ERROR_STATE_RETRY: 'Tentar novamente',

    META_STATUS_APPROVED: 'Aprovado',
    META_STATUS_PENDING: 'Pendente',
    META_STATUS_REJECTED: 'Rejeitado',
    META_STATUS_PAUSED: 'Pausado',

    CATEGORY_MARKETING: 'Marketing',
    CATEGORY_UTILITY: 'Utilidade',
    CATEGORY_AUTHENTICATION: 'Autenticação',

    PLACEHOLDER_FORMAT_NAMED: 'Nomeado',
    PLACEHOLDER_FORMAT_POSITIONAL: 'Posicional',

    MAPPING_STATUS: '{{mapped}}/{{total}}',

    ROUTE_LOADING_LABEL: 'Carregando a página',

    SEND_TEST_BUTTON: 'Testar envio',
    SEND_TEST_DISABLED_NO_TEMPLATES:
      'Este produto não tem modelos. Importe um modelo para testar um envio.',
    SEND_TEST_TITLE: 'Testar envio de WhatsApp',
    SEND_TEST_DESCRIPTION:
      'Envia uma mensagem real com send_whatsapp, a mesma operação que os produtos usam. Cada destinatário recebe a mensagem.',
    SEND_TEST_CLOSE: 'Fechar',
    SEND_TEST_TEMPLATE_LABEL: 'Modelo (template_slug)',
    SEND_TEST_TEMPLATE_PLACEHOLDER: 'Escolha um modelo',
    SEND_TEST_TEMPLATE_OPTION: '{{alias}} · {{slug}}',
    SEND_TEST_ORGANIZATION_LABEL:
      'ID da organização (centralized_organization_id)',
    SEND_TEST_VARIABLES_TITLE: 'Variáveis (variables)',
    SEND_TEST_VARIABLES_CHOOSE_TEMPLATE:
      'Escolha um modelo para ver as variáveis.',
    SEND_TEST_VARIABLES_NONE:
      'Este modelo não precisa de variáveis do produto.',
    SEND_TEST_VARIABLES_DESCRIPTION: 'Valores para todos os destinatários.',
    SEND_TEST_VARIABLE_REQUIRED: '{{key}} (obrigatória)',
    SEND_TEST_PROFILE_VARIABLES:
      'Do perfil do destinatário: {{keys}}. O destinatário deve ser membro da organização.',
    SEND_TEST_RECIPIENTS_TITLE: 'Destinatários (recipients)',
    SEND_TEST_RECIPIENT_TITLE: 'Destinatário {{index}}',
    SEND_TEST_RECIPIENT_ADD: 'Adicionar destinatário',
    SEND_TEST_RECIPIENT_REMOVE: 'Remover destinatário {{index}}',
    SEND_TEST_USER_ID_LABEL: 'ID do usuário (centralized_user_id)',
    SEND_TEST_PHONE_LABEL: 'Telefone (phone)',
    SEND_TEST_PHONE_PLACEHOLDER: '+51987654321',
    SEND_TEST_COUNTRY_LABEL: 'País (country_iso_code)',
    SEND_TEST_COUNTRY_PLACEHOLDER: 'PE',
    SEND_TEST_OVERRIDES_TRIGGER: 'Variáveis só para este destinatário',
    SEND_TEST_OVERRIDES_DESCRIPTION:
      'Opcional. Um valor aqui substitui o valor comum para este destinatário.',
    SEND_TEST_SOURCE_TITLE: 'Origem (source)',
    SEND_TEST_SOURCE_DESCRIPTION:
      'Opcional. Se você preencher target_type ou target_id, preencha também app_name.',
    SEND_TEST_APP_NAME_LABEL: 'app_name',
    SEND_TEST_TARGET_TYPE_LABEL: 'target_type',
    SEND_TEST_TARGET_ID_LABEL: 'target_id',
    SEND_TEST_CANCEL: 'Cancelar',
    SEND_TEST_SUBMIT: 'Enviar',
    SEND_TEST_TOAST_TITLE: 'Envio na fila',
    SEND_TEST_TOAST_DESCRIPTION:
      'ID: {{sendId}} · Status: {{status}} · Destinatários: {{count}}',
    SEND_TEST_ERROR_TITLE: 'O envio não foi feito',
    SEND_TEST_ERROR_NETWORK: 'O servidor não respondeu.',
    SEND_TEST_ERROR_ISSUE: '{{code}}: {{message}}',
    SEND_TEST_ERROR_ISSUE_FIELD: '{{code}} · {{field}}: {{message}}',
    SEND_TEST_ERROR_REQUIRED: 'Preencha este campo.',
    SEND_TEST_ERROR_INTEGER: 'Digite apenas números.',
    SEND_TEST_ERROR_PHONE:
      'Digite o número com + e o código do país, por exemplo +51987654321.',
    SEND_TEST_ERROR_RECIPIENTS_MIN: 'Adicione pelo menos um destinatário.',
    SEND_TEST_ERROR_RECIPIENTS_MAX:
      'Envie para no máximo {{max}} destinatários.',
    SEND_TEST_ERROR_MAX_LENGTH: 'Digite no máximo {{max}} caracteres.',
    SEND_TEST_ERROR_APP_NAME_REQUIRED:
      'Preencha app_name quando enviar target_type ou target_id.',
    SEND_TEST_ERROR_VARIABLE_REQUIRED:
      'Preencha este valor aqui ou em cada destinatário.',
  },
};
